import moment from 'moment';
import Logger from '../../functions/logging';

import { SET_ACTIVITY_LIST, SET_MY_LIST, ADD_STUDY_TO_MY_LIST, INVALIDATE_ACTIVITY_LIST, INVALIDATE_MY_LIST } from '../actions/constants';

const INITIAL_STATE = {
	activityList: [],
	activityListTimestamp: null,
	myList: [],
	myListTimestamp: null
};

export default function (state = INITIAL_STATE, action) {
	Logger.log("homelists.js REDUCER()", action.type);

	switch (action.type) {
		case SET_ACTIVITY_LIST: {
			let newState = {};
			if (Array.isArray(action.activityList) && action.activityList.length) {
				newState = { ...state, activityList: action.activityList, activityListTimestamp: moment() };
			}
			else {
				newState = { ...state, activityList: [], activityListTimestamp: null };
			}
			return newState;
		}
		case SET_MY_LIST: {
			let newState = {};
			if (Array.isArray(action.myList) && action.myList.length) {
				newState = { ...state, myList: action.myList, myListTimestamp: moment() };
			}
			else {
				newState = { ...state, myList: [], myListTimestamp: null };
			}
			return newState;
		}
		case INVALIDATE_ACTIVITY_LIST: {
			return { ...state, activityListTimestamp: null };
		}
		case INVALIDATE_MY_LIST: {
			return { ...state, myListTimestamp: null };
		}
		case ADD_STUDY_TO_MY_LIST: {
			if (!action.study) {
				return state;
			}

			let newState = {...state};

			let userData = {
				complete: 0,
				group_id: action.study._id.valueOf(),
				mylist: 1,
				screened: 0,
				status: 1
			};

			// invalidate timestamp and add study to MyList
			// - we only really need to invalidate. we add so when user selects 
			//   MyList, the item appears in the list while it reloads
			let newMyList = [...state.myList];
			let myListTimestamp = state.myListTimestamp;
			let found = false;
			for (let i = 0; i < newMyList.length; i++) {
				if (newMyList[i]._id.valueOf() === action.study._id.valueOf()) {
					found = true;
					break;
				}
			}
			if (!found) {
				action.study.userData = userData;
				newMyList.unshift(action.study);
				myListTimestamp = null;
			}

			// Update study's userData in ActivityList
			if (newState.activityList) {
				for (let i = 0; i < newState.activityList.length; i++) {
					let item = newState.activityList[i];
					if (item._id.valueOf() === action.study._id.valueOf()) {
						if (!item.userData) {
							item.userData = userData;
						}
						item.userData.myList = 1;
						break;
					}
				}
			}

			return { ...newState, myList: newMyList, myListTimestamp: myListTimestamp };
		}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/homeLists.js